export function createPurger(options) {
    return function (_a) {
        var purge = _a.purge;
        var timeout = setTimeout(purge, options.ttl);
        return function () {
            clearTimeout(timeout);
        };
    };
}
//# sourceMappingURL=purger.js.map